import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfirmpopupService {
  /* *
this service is used to open the toast component 
@author suresh 15/10/2025
*/
private confirmPopupService=new BehaviorSubject<any>({})
private confirmAcceptbutton=new BehaviorSubject<any>({})
getAcceptButtonAction():Observable<any>{
return this.confirmAcceptbutton;
}
getConfirmPopup():Observable<any>{
return this.confirmPopupService

}
setAcceptButtonAction(message:any){
  //console.log(message)
this.confirmAcceptbutton.next(message);
}
showConfirmPopup(message:any){
  //console.log(message)
this.confirmPopupService.next(message);
}

  constructor() { }
}
